import { TextPatternScannerUiResult, mapRTUUIResult, withSBErrorHandling, } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotTextPatternImpl = {
    async startScanner(configuration) {
        return withSBErrorHandling(async () => mapRTUUIResult(await ScanbotSDKPlugin.startTextPatternScanner(configuration), TextPatternScannerUiResult));
    },
};
//# sourceMappingURL=TextPatternImpl.js.map